import { AlertRow } from '@components/AlertCenter/AlertRows/AlertRow';
import { useTranslations } from '@services/hooks/translations/useTranslations';
import { useNavigate } from 'react-router-dom';
import { ProfilePictureAvatar } from '@components/Avatars/ProfiePictureAvatar';
import { useQueryParamsModal } from '@utils/navigation/queryParamsNavigation';

export const TermsAndConditionsAlertRow = () => {
  const {
    translate,
    translations: {
      alertCenter: { myAccount },
    },
  } = useTranslations();

  const navigate = useNavigate();
  const { closeModal } = useQueryParamsModal(`alerts`);

  const goToProfile = () => {
    closeModal();
    navigate(`/my-account?modal=termsAndConditions`);
  };

  return (
    <AlertRow
      Icon={<ProfilePictureAvatar />}
      title={translate(myAccount.termsAndConditions.title)}
      actionText={translate(myAccount.termsAndConditions.path)}
      subtitle={translate(myAccount.subtitle)}
      action={goToProfile}
    />
  );
};
